import styled from 'styled-components'

export const Layout = styled.div`
  height: 100vh;
  display: grid;
  background-color: ${props => props.theme.colors.background.primary};

  & > div {
    margin: ${props => props.theme.spacing.sp64};
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp64};
  margin-right: ${props => props.theme.spacing.sp64};
`

export const Container = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 0.75fr;
`

export const SideImageContainer = styled.div`
  background-image: url('/images/signupBackground.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 48px;

  display: flex;
  justify-content: end;
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp64};
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${props => props.theme.spacing.sp32};
`

export const ReveniLogo = styled.img`
  height: ${props => props.theme.size.L};
`

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
`

export const ConditionsContainer = styled.div`
  margin-bottom: 1rem;
  margin: ${props => props.theme.spacing.sp32} 0;
`
